<style lang="less">
	.c-inline-block{
		display: -webkit-inline-box;
	}

	.smaller{
		font-size: 11px !important;
		height: 20px !important;
		padding: 9px;
	}
</style>
<template>

	<v-card class="mx-auto mr-3 mb-4 c-inline-block" min-width="385px" min-height="100px" v-if="project">
		<v-container>
					<v-card-title>
						<v-icon class="mr-2" style="font-size: 2em">{{icon}}</v-icon>	
						<span class="title">{{project.participantName ? project.participantName : project.clientName }}</span>
					</v-card-title>
					<v-card-subtitle>
						<span class="subtitle-2">{{appointmentType}}</span> 
						<p class="subtitle-2">{{ localAppointmentTimeString  }} </p>
					</v-card-subtitle>
					<v-card-text>
						<v-btn color="green" v-if="notYet" dark link :href="`/appointment-setup/${appointment.id}`">Appointment Set Up</v-btn>
						<div v-if="isVideo">
							<p class="font-weight-thin" v-if="appointment.videoMeeting">	{{appointment.videoMeeting.clientInstructions}}</p>
						</div>
						<div v-if="isPhone">
							<p>This is a telephone appointment. The phone number we have on record for you is: {{userInfo.phone}}</p>
							<v-text-field v-model="alternativeNumber" label="Provide an alternative contact number:"></v-text-field>
							<p class="text-right">
								<v-btn @click="saveAlternativeNumber" color="green" dark>Save</v-btn>	
							</p>
						</div>
					</v-card-text>
					<v-card-actions  class="mt-0">
							<v-spacer></v-spacer>
							<div v-if="isVideo" class="text-right">
									<div v-if="passed">
										<v-chip class="text-right mb-0">Appointment has passed</v-chip>
									</div>
									<v-dialog v-model="pemissionDialog" max-width="360" v-if="videoAvailable" >
										<template v-slot:activator="{ on }">
										<v-btn 
										color="primary"
										dark
										v-on="on" >
										Start Meeting
										</v-btn>
										</template>
											<AllowRecording :appointment="appointment.id" v-on:declined="pemissionDialog = false" v-on:allowed="goToVideo"></AllowRecording>
									</v-dialog>
									<div v-else class="text-right">
										<v-chip v-if="notYet" class="text-right mb-0">Appointment has not yet started</v-chip>
									</div>
							<p class="text-right mt-2"><a :href="'mailto:dev@m.works?subject=Appointment ['+appointment.id+ '] has not begun on time'" target="blank">My session hasn't started</a></p>
							</div>
							<br/>
					</v-card-actions>
			
		</v-container>
	</v-card>
</template>


<script>
	import Vue from "vue";
	
	import {localDateTimeString} from "../../assets/timezoneFunctions.js"
	import Vuex from "vuex";
	import AllowRecording from "../communication/video/AllowRecording.vue"
	import {prettyPrint} from "../../assets/utilities.js";
	export default {
		name: "ParticipantAppointmentTile", 
		props: {
			appointment: {type: Object}, 
		},
		components: {
			AllowRecording: AllowRecording
		},
		data: () => {
			return {
				pemissionDialog: false, 
				alternativeNumber: ''
			}
		},
		computed:{
			...Vuex.mapState({
				userInfo: state => state[state.auth.view].user,
				project(state){
					var id = this.appointment.project;
					return state[state.auth.view].projects.find( p => p.id == id )
				},
			}),
			isVideo(){
				return this.appointment.methodology == 'video' && this.project.includeVideoCalling;
			},
			isPhone(){
				return this.appointment.methodology == 'phone' && this.project.includeVideoCalling;
			},
			notYet(){
				var appt = this.appointment.dateTime.toDate();
				var windowStart = Vue.moment(appt).subtract(10, 'm').toDate();
				var now = new Date();
				return now < windowStart;
			},
			passed(){
				var appt = this.appointment.dateTime.toDate();
				var windowEnd =  Vue.moment(appt).add(3, 'h').toDate();
				var now = new Date();
				return now > windowEnd;
			},
			videoAvailable(){
				var appt = this.appointment.dateTime.toDate();
				var windowStart = Vue.moment(appt).subtract(10, 'm').toDate();
				var windowEnd =  Vue.moment(appt).add(3, 'h').toDate();
				var now = new Date();
				return now > windowStart && now < windowEnd;
			},
			localAppointmentTimeString(){
				if( !this.appointment.dateTime ){ return ""; }
				return localDateTimeString(this.userInfo, this.appointment.dateTime.toDate(), "LONG" )
			},
			appointmentType(){
				return prettyPrint(this.appointment.methodology + " appointment", "SENTENCE")
			},
			icon: function(){
				switch( this.appointment.methodology ){
					case "phone":
						return "mdi-phone-in-talk";
					case "video":
						return "mdi-video-account";
					default: 
						return "mdi-comment-account";
				}	
			}
		},
		methods:{ 
			goToVideo(){
				this.$router.replace({ name:'video', params: {appointment: this.appointment.id }} )
			},
			saveAlternativeNumber(){
				const self = this;
				self.$store.dispatch("updateDoc", {
					doc: "appointments/" + self.appointment.id, 
					data: {
						participantPhone: self.alternativeNumber
					}, 
					action: "update"
				}).then(() => {
					self.$emit("saved");
					self.$store.dispatch("addDoc", {
						collection: "users/" + self.userInfo.id + "/alternativeContacts",
						data: {
							phone: self.alternativeNumber
						}, 
					})
				})
			}
		},
		created(){
			if( this.appointment.participantPhone ){
				this.alternativeNumber = this.appointment.participantPhone;
			}
			this.$store.dispatch( 'fetchProject', this.appointment.project );
		}
	}
</script>